export const ServiceInvoiceData = [
  {
    invoiceNo: "INV-006",
    serviceId: "Service006",
    customer: "Rakesh Mehta",
    productName: "Dell Inspiron 15",
    serialNumber: "SN56473829",
    InvoiceDate: "09 October 2024",
    issues: [
      { name: "Screen Replacement", price: 4500, qty: 1 },
      { name: "Battery Replacement", price: 2200, qty: 1 },
      { name: "Service Charge", price: 500, qty: 1 }
    ],
    discountpercent: 13,
    billTo: {
      name: "Mrs. Priya Kulkarni",
      flatNo: "A-502,",
      societyname: "Sunshine Meadows,",
      city: "Hadapsar, Pune",
      pincode: " - 411028"
    }
  },
  {
    invoiceNo: "INV-007",
    serviceId: "Service007",
    gstin: "27ABCDE1234F1Z5",
    customer: "Sneha Patil",
    productName: "HP Pavilion x360",
    serialNumber: "SN99887766",
    InvoiceDate: "15 October 2024",
    issues: [
      { name: "Keyboard Replacement", price: 1800, qty: 1 },
      { name: "Hinge Fixing", price: 1200, qty: 1 },
      { name: "Service Charge", price: 500, qty: 1 }
    ],
    discountpercent: 10,
    billTo: {
      name: "Mrs. Priya Kulkarni",
      flatNo: "A-502,",
      societyname: "Sunshine Meadows,",
      city: "Hadapsar, Pune",
      pincode: " - 411028"
    }
  },
  {
    invoiceNo: "INV-008",
    serviceId: "Service008",
    gstin: "27ABCDE1234F1Z5",
    customer: "Amit Sharma",
    productName: "Lenovo ThinkPad T14",
    serialNumber: "SN44556677",
    InvoiceDate: "20 October 2024",
    issues: [
      { name: "Motherboard Repair", price: 6500, qty: 1 },
      { name: "RAM Upgrade", price: 2800, qty: 1 },
      { name: "Service Charge", price: 500, qty: 1 }
    ],
    discountpercent: 15,
    billTo: {
      name: "Mrs. Priya Kulkarni",
      flatNo: "A-502,",
      societyname: "Sunshine Meadows,",
      city: "Hadapsar, Pune",
      pincode: " - 411028"
    }
  },
  {
    invoiceNo: "INV-009",
    serviceId: "Service009",
    gstin: "27ABCDE1234F1Z5",
    customer: "Priya Nair",
    productName: "MacBook Air M1",
    serialNumber: "SN11223344",
    InvoiceDate: "25 October 2024",
    issues: [
      { name: "SSD Replacement", price: 5000, qty: 1 },
      { name: "Fan Cleaning", price: 600, qty: 1 },
      { name: "Service Charge", price: 500, qty: 1 }
    ],
    discountpercent: 12,
    billTo: {
      name: "Mrs. Priya Kulkarni",
      flatNo: "A-502,",
      societyname: "Sunshine Meadows,",
      city: "Hadapsar, Pune",
      pincode: " - 411028"
    }
  }
];
